// import { PeerConnection } from "./peer_connection";
import { SessionTypes } from "./types";

/**
 * @typedef {Object} SessionContextOptions
 * @param {string} userDisplayName - the display name of the user
 * @param {int} statsInterval - the interval for sending stats
 * @param {boolean} webrtcQualityEnabled - whether to enable WebRTC quality
 * @param {Object} rtcPeerConnectionConfig - the RTC peer connection config
 */

export class SessionContext {
    /**
     * @param {JoinData} joinData - the server join endpoint data
     * @param {SessionTypes} sessionType - the type of the session (meeting | monitoring | test)
     * @param {MediaStream} localMediaStream - the local media stream
     * @param {SessionContextOptions} options
     */
    constructor({ joinData, sessionType, localMediaStream, options = {} }) {
        this.audioContext = new AudioContext({ latencyHint: "interactive" });
        this.joinData = joinData;
        this.sessionType = sessionType;
        this.localMediaStream = localMediaStream;
        this.options = options;

        if (!this.joinData) {
            throw new Error("joinData is required");
        }
        if (!(this.sessionType in SessionTypes)) {
            throw new Error(`Invalid sessionType: ${this.sessionType}`);
        }
        if (!this.localMediaStream) {
            throw new Error("localMediaStream is required");
        }

        // set default options if not provided
        this.options.userDisplayName = this.options.userDisplayName || "guest"
        this.options.statsInterval = this.options.statsInterval || 60
        this.options.rtcPeerConnectionConfig = this.options.rtcPeerConnectionConfig || {
            bundlePolicy: 'max-bundle',
            iceCandidatePoolSize: 16,
            iceTransportPolicy: 'all',
            // rtcpMuxPolicy: 'require',
            iceServers: [
                { urls: 'stun:stun.l.google.com:19302' },
            ],
        };
    }

    // get videoDeviceConnection() {
    //     return this.#videoDeviceConnection;
    // }

    // set videoDeviceConnection(videoDeviceConnection) {
    //     if (videoDeviceConnection instanceof PeerConnection) {
    //         this.#videoDeviceConnection = videoDeviceConnection;
    //     } else {
    //         throw new Error("videoDeviceConnection must be an instance of PeerConnection");
    //     }
    // }

    // get videoDeviceKioskConnection() {
    //     return this.#videoDeviceKioskConnection;
    // }

    // get aimeeConnection() {
    //     return this.#aimeeConnection;
    // }

    // get otherUserConnections() {
    //     return this.#otherUserConnections;
    // }

}